<template>
	<div class="survey">
			
			<!--<b-modal id="setpassword" title="Change Password" ok-only @hidden="resetSelectedForm" >-->
			<b-modal id="surveysellerpopup" title="Survey"   ok-only   hide-header hide-footer no-close-on-backdrop size="md" centered>
			<div  class="surveypop" v-if="thanksStep==0">
				<!-- <template #modal-header>
				   
				  <h5 class="modal-title"> POP HEADER </h5>
				 
				  <button type="button" aria-label="Close" @click="$root.closeMeShareModel('showShareModal')" class="close">×</button>
				</template> @click="$bvModal.hide('bv-modal-example')" -->
				
				<!--<div class="text-right"> <button type="button" aria-label="Close" class=" closeMe" @click="$bvModal.hide('surveypopup')">×</button></div> -->
				<!--<div class="text-right"> <b-link  class=" closeMe" @click="$bvModal.hide('surveypopup'),remindmelater()">×</b-link></div> -->
				<b-row class="surveyP1">
					<b-col class="text-center p-0" v-if="step==0">
							<h6 class="font-bold text-center text-3xl mb-0" > The Social eCommerce Platform led by  Influencers!</h6>
							<p>We value your feedback. Please help us serve you better through this survey.</p>
					</b-col>
					<b-col class="text-center p-0" v-else>
							
							<p>Thank You for your valuable feedback! </p>
							<h6 class="font-bold text-center text-3xl mb-0" > The Social eCommerce Platform led by Influencers!</h6>
					</b-col>
				</b-row>
				
				
				<b-row class="surveyP2" v-if="step==0">
					<b-col class="p-0">
						<ul >
							<li>1. Does your brand have online presence? Which Tech (enablement) platform you prefer the most?</li>
							<li>
								
								<b-form-group >
								<b-form-checkbox-group
									id="btn-radios-question01"
									v-model="question.question01"
									:options="options1"
									:aria-describedby="ariaDescribedby"
									name="question01"
									class="mybtnsty2"
								  ></b-form-checkbox-group>
								
								<!-- <b-form-checkbox-group
									id="btn-radios-question01"
									v-model="question.question01"
									:options="options1"
									name="question01"
									size="sm"
									buttons
									class="mybtnstyl"
								  ></b-form-checkbox-group> -->
								  </b-form-group>
							
							</li>
						</ul>
						<ul >
							<li>2. Are you struggling to manage business on online platforms? What are major pain points?</li>
							<li>
								
								<b-form-group >
								<b-form-checkbox-group
									id="btn-radios-question02"
									v-model="question.question02"
									:options="options2"
									:aria-describedby="ariaDescribedby"
									name="question02"
									class="mybtnsty2"
								  ></b-form-checkbox-group>
								 <!--<b-form-checkbox-group
									id="btn-radios-question02"
									v-model="question.question02"
									:options="options2"
									name="question02"
									size="sm"
									buttons
									class="mybtnstyl"
								  ></b-form-checkbox-group> -->
								  </b-form-group>
							
							</li>
						</ul>
						<ul >
							<li>3. Are you happy with Marketing help/support you get from Tech (enablement) platforms?</li>
							<li>
								<b-form-group >
								  <b-form-radio-group
									v-model="question.question03"
									:options="optionsYesno"
									:aria-describedby="ariaDescribedby"
									name="question03"
									plain
									class="yesnoBtn"
								  ></b-form-radio-group>
								</b-form-group>
							
							</li>
						</ul>
						<ul >
							<li>4. Do you have your own digital marketing team?</li>
							<li>
								<b-form-group >
								  <b-form-radio-group
									v-model="question.question04"
									:options="optionsYesno"
									name="question04"
									plain
									class="yesnoBtn"
								  ></b-form-radio-group>
								</b-form-group>
							
							</li>
						</ul>
						<ul >
							<li>5. Do you wish to get more help with marketing on tech (enablement) platforms?</li>
							<li>
								<b-form-group >
								  <b-form-radio-group
									v-model="question.question05"
									:options="optionsYesno"
									name="question05"
									plain
									class="yesnoBtn"
								  ></b-form-radio-group>
								</b-form-group>
							
							</li>
						</ul>
						<ul >
							<li>6. Would you be open to list your brands/products which offers Tech platform and Marketing both?</li>
							<li>
								<b-form-group >
								  <b-form-radio-group
									v-model="question.question06"
									:options="optionsYesno"
									name="question06"
									plain
									class="yesnoBtn"
								  ></b-form-radio-group>
								</b-form-group>
							
							</li>
						</ul>
						
						
						
						
						
						
						<!--<p class=" mb-4 text-xs">{{question}}</p> -->
							
					</b-col>
				</b-row>
				
				<b-row class="mt-4" v-else >
					<b-col>
							<b-row class="px-0 mb-3">
								<b-col >
									<b-form-group label-for="name-input" label-size="sm" label-class="mb-0" class="mb-1" :state="questionState.name"  invalid-feedback="Full Name is required!">
									<b-form-input id="name-input" v-model="question.name" :state="registerState.name" placeholder="*Full Name" @focusin="questionState.name = null"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="px-0 mb-3">
								<b-col>							
									<b-form-group :state="questionState.email" label-for="emailC-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Email should be valid">
									<b-form-input id="emailC-input" v-model="question.email" :state="questionState.email" placeholder="*Email" @focusin="questionState.email = null"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="px-0 mb-3">
								<b-col>
									<b-form-group :state="questionState.mobile" label-for="mobile-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Mobile should be valid">
									<b-form-input id="mobile-input" v-model="question.mobile" :state="questionState.mobile" placeholder="*Mobile" @focusin="questionState.mobile = null" maxlength="10"></b-form-input>
									</b-form-group> 
								</b-col>
							</b-row>
				    </b-col>
				</b-row>
				
				<b-row class="m-0">
					<!--<b-col class="text-left pl-0">
						
						<b-button @click="$bvModal.hide('surveypopup'),remindmelater(),closeWindow()"  class=" text-xs w-full  block rounded  visited:text-white bg-red-700 font-bold" variant="light" style="border:1px solid #c6c6c670;" >Remind me later</b-button>
						
					</b-col> -->
					<b-col class="text-center  mt-2">
						<b-button  v-if="step==0" class="text-xs w-full  block rounded text-white visited:text-white bg-red-700 font-bold submitfeedback" @click="step=1" style="font-weight: 600;width:auto;">Submit Feedback</b-button>
					  <b-button  v-else class="text-xs w-full  block rounded text-white visited:text-white bg-red-700 font-bold submitfeedback" @click="remindmelater()" style="font-weight: 600;width: 40%">Submit</b-button>
							
					</b-col>
				</b-row>
				
				</div>
				<div  class="surveypop" v-else>
				<b-row class="thanksPopup">
					
					<b-col class="text-center p-0" >
							<h6 class="font-bold text-center text-3xl mb-0" > Thank you for participating in the Survey!</h6>
							<p> As we work on the feedback please continue using <b-link @click="closeMe()">www.alluraa.com!</b-link> </p>
					</b-col>
				</b-row>
						
				</div>
				
					<!-- <b-link :href="urlLink" >
					 <b-img-lazy  fluid  rounded alt="surveypopup" :src="$root.MEDIAPATH+'/images/cONTESTPopUpBanner.jpeg'"></b-img-lazy> </b-link> 
					 
					 <div class="text-center"> <button type="button" class=" closeRem" @click="remindmelater()">Remind me later</button></div>-->
				
				
			  </b-modal>
			

	</div>		
</template>
<script>

/* setpassword

http://localhost:8080/agent/dashboard/setpassword*/

//import CartVariant from "@/components/cartVariant.vue";
//import ProductRating from "@/components/product-rating.vue";
import '../assets/surveysellerpopup.scss';

export default {
  name: 'ShareEmailPopup',
  components: {
  //"cart-variant": CartVariant,
  //"product-rating": ProductRating,
  
  },
  created(){
	
  },
  mounted(){
    this.inLodcard();
	var roleIdmy =this.$root.customer_info.role;
	if(roleIdmy>0){
		this.myrole=roleIdmy;
		this.urlLink='/agent/my-shop';
	}
  },
  computed: {
    
  },
  data() {
    return{
		 userIdUri:'', 
		 coform_password: '', 
      new_password: '', 
	  coform_passwordState: null, 
      new_passwordState:null, 
      passwordUrl: this.$root.WEBAPI+'webapi/passwordSet',
      urlprmoCoutUrl: this.$root.WEBAPI+'webapi/postsurveyseller',
		linkComments:'',
		iamiconfor:'',
		register: {
				new_password:'',
				conformpassword:'',
				rowId:'',
				user_id:'',
            },
			registerState:{
				new_password:null,
				conformpassword:null,
			},
			registerError:{
				new_password:'Please enter password!',
				conformpassword:'Please reenter password!',
			},
			urlLink:'/login',
			myrole:0,
			question:{question01:'',
					 question02:'',
					 question03:'',
					 question04:'',
					 question05:'',
					 question06:'',
					 question07:'',
					 question08:'',
					 name:'',
					 email:'',
					 mobile:'',
					 },
				questionState:{
					 name:null,
					 email:null,
					 mobile:null,
					 },
			
			optionsYesno: [
			  { text: 'Yes', value: '1' },
			  { text: 'No', value: '0' }
			],
			optionsQ2: [
			  { text: 'Apparel', value: 'Apparel' },
			  { text: 'Cosmetics', value: 'Cosmetics' },
			  { text: 'Home Decor', value: 'Home Decor' },
			  { text: 'Organic Products', value: 'Organic Products' },
			  { text: 'Others', value: 'Others' }
			],
			options10: [
			  { text: '1', value: '1' },
			  { text: '2', value: '2' },
			  { text: '3', value: '3' },
			  { text: '4', value: '4' },
			  { text: '5', value: '5' },
			  { text: '6', value: '6' },
			  { text: '7', value: '7' },
			  { text: '8', value: '8' },
			  { text: '9', value: '9' },
			  { text: '10', value: '10' },
			  
			],options11: [
			  { text: 'Poor', value: 'Poor' },
			  { text: 'Fair', value: 'Fair' },
			  { text: 'Good', value: 'Good' },
			  { text: 'Very Good', value: 'Very Good' },
			  { text: 'Excellent', value: 'Excellent' }
			],options1: [
			  { text: 'Amazon', value: 'Amazon' },
			  { text: 'Flipkart', value: 'Flipkart' },
			  { text: 'Dukaan', value: 'Dukaan' },
			  { text: 'Own Website', value: 'Own Website' },
			  { text: 'Others', value: 'Others' }
			],options2: [
			  { text: 'Few orders', value: 'Few orders' },
			  { text: 'Order cancellations', value: 'Order cancellations' },
			  { text: 'Order Returns', value: 'Order Returns' },			  
			  { text: 'Marketing Support', value: 'Marketing Support' }
			  
			],
			step:0,
			thanksStep:0,
			ariaDescribedby:'',
		
    }
  },
  methods:{
	/* inLodcard(){
		alert('dasd');
	},*/
	inLodcard(){			
			//this.linkComments = this.social_options[this.$root.share.social];
			this.userIdUri = this.$route.params.userId;
			//console.log('userIdUri'+this.userIdUri); 
		},
		changeMessage(arg){		  
            //console.log('CHANGE MESSAGE '+social_options[$root.share.social]);
            this.linkComments = this.social_options[arg];
			
        },
		checkFormValidityCR() { 
				var valid = true;
				if(this.question.name.length < 3){
					valid = false;
					this.questionState.name= false;
				}else{
					this.questionState.name = true;
				} 
				if(!this.validateemail(this.question.email)){
				  valid = false;
				  this.questionState.email = false;
				}else{
				  this.questionState.email = true;
				}
				if(this.question.mobile.length < 10){
					valid = false;
					this.questionState.mobile = false;
				}else{
					this.questionState.mobile= true;
				}
				
				return valid;
			},
			validateemail(email){
				var atposition=email.indexOf("@");  
				var dotposition=email.lastIndexOf(".");  
				if (atposition<1 || dotposition<atposition+2 || dotposition+2>=email.length){ 
				return false;  
				}else{
				return true;
				}
			},		
		remindmelater(){
			if (!this.checkFormValidityCR()) {
					return;
				}
			var self=this;
			//this.$root.remindmelater = 1;
			//this.$root.customer_info.remindmelater;
			//self.$session.set('remindmelater',1);
			//self.$bvModal.hide('surveysellerpopup');
			self.thanksStep=1;
			
			var userIdlogin = self.$root.customer_info.user_id;
			if(typeof(self.userIdUri)!="undefined"){
				userIdlogin =  atob(self.userIdUri);
			}
			
				self.axios.post(self.urlprmoCoutUrl, {
					  accesskey: self.$root.customer_info.access_key,
					  user_id : userIdlogin,
					  question : self.question
				  }).then(function (response) {
					  if(response.data.error == 0 || response.data.error == '0'){
					  setInterval(self.closeMe,1000);
						 
						 console.log('count'); 
						 /* if(typeof(self.userIdUri)!="undefined"){
							//self.$router.push('/');
							window.location.href = '/';
						 } */
					  }
				  }).catch(function (error) {
					  alert(error);
					 
				  });
			
			
		},
		closeMe(){
			this.$bvModal.hide('surveysellerpopup');
			window.location.href = '/';
		},
		closeWindow(){
			window.close();
			//opener.window.focus();
			
		}

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
	
	
</style>
